import React, { useState } from "react";
import { Loader2, Lock, Mail } from "lucide-react";
import { ARIA } from "../lib/assets";
import { loginEmail } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [mode, setMode] = useState("google");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError(""); setLoading(true);
    try {
      await loginEmail(email.trim(), password);
      window.location.href = "/";
    } catch (ex) {
      const d = ex.response?.data?.detail;
      setError(typeof d === "string" ? d : "Sign-in failed. Please check your credentials.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0908] grain relative flex items-center justify-center p-6">
      <img src={ARIA.hero} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(10,9,8,0.97) 40%, rgba(10,9,8,0.6) 100%)" }} />
      <div className="relative max-w-md w-full text-center fade-up">
        <img src={ARIA.portrait} alt="Aria" className="w-24 h-24 rounded-full object-cover mx-auto border border-amber-400/40 shadow-[0_0_50px_-8px_rgba(226,184,87,0.7)]" />
        <div className="overline mt-6">Executive Operating System</div>
        <h1 className="font-display text-5xl sm:text-6xl font-light text-amber-50 mt-3 leading-[1.05]">
          Meet <span className="italic text-amber-300/90">Aria.</span>
        </h1>
        <p className="text-slate-300/85 mt-4 font-light text-base leading-relaxed">
          Your private AI Executive Chief of Staff. Sign in to enter your office.
        </p>

        {mode === "google" ? (
          <>
            <button onClick={signIn} className="mt-8 w-full gold-btn rounded-xl py-3.5 flex items-center justify-center gap-3 text-[15px]" data-testid="google-signin-button">
              <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#1c1407" d="M21.35 11.1H12v3.8h5.35c-.25 1.5-1.9 4.4-5.35 4.4-3.2 0-5.8-2.65-5.8-5.9s2.6-5.9 5.8-5.9c1.8 0 3.05.77 3.75 1.43l2.55-2.46C16.7 3.6 14.6 2.7 12 2.7 6.9 2.7 2.8 6.8 2.8 12s4.1 9.3 9.2 9.3c5.3 0 8.8-3.72 8.8-8.97 0-.6-.06-1.06-.15-1.53z"/></svg>
              Continue with Google
            </button>
            <button onClick={() => { setMode("email"); setError(""); }} className="mt-3 w-full rounded-xl py-3 flex items-center justify-center gap-2 text-[14px] text-amber-200/90 border border-amber-400/25 hover:border-amber-400/50 transition" data-testid="email-mode-button">
              <Lock size={15} /> Sign in with email &amp; password
            </button>
          </>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-3 text-left">
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus
                placeholder="you@email.com"
                className="w-full bg-[#12100D] border border-white/12 rounded-xl pl-10 pr-4 py-3 text-sm text-amber-50 focus:outline-none focus:border-amber-500/50"
                data-testid="login-email-input" />
            </div>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                placeholder="Password"
                className="w-full bg-[#12100D] border border-white/12 rounded-xl pl-10 pr-4 py-3 text-sm text-amber-50 focus:outline-none focus:border-amber-500/50"
                data-testid="login-password-input" />
            </div>
            {error && <div className="text-rose-400 text-sm" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="w-full gold-btn rounded-xl py-3.5 flex items-center justify-center gap-2 text-[15px] disabled:opacity-50" data-testid="login-submit-button">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Sign in
            </button>
            <button type="button" onClick={() => { setMode("google"); setError(""); }} className="w-full text-center text-[13px] text-slate-400 hover:text-amber-200 transition" data-testid="back-to-google-button">
              Back to Google sign-in
            </button>
          </form>
        )}

        <p className="text-[11px] text-slate-500 mt-4">Secure sign-in. Access is restricted to authorized accounts only.</p>
      </div>
    </div>
  );
}
